<template>
  <div>
    <SfHeading v-e2e="'shipping-heading'" :level="3" :title="$t('Shipping_title')"
      class="sf-heading--left sf-heading--no-underline title" />
    <div>
      <ShippingAddressSelect :addressId="addressId" @getAddress="selectAddress" :source="'Shipping'" />
      <div style="margin:1rem 0;">
        <SfCheckbox v-e2e="'billingAndShipping'" v-model="billingAndShipping" name="billingAndShipping"
          class="summary__terms" @change="billingAddressChange">
          <template #label>
            <div class="sf-checkbox__label">
              {{ $t('billing_and_shipping') }}
            </div>
          </template>
        </SfCheckbox>
      </div>
      <SfButton :disabled="!addressId ||
        (preOrderErr && preOrderErr.load != null) ||
        (preorder && preorder.errs && preorder.errs.length != 0)
        " type="button" @click="goNext" class="margintop">
        {{ $t('Continue_billing') }}
      </SfButton>
    </div>
    <SfModal v-if="show" :title="$t('prompt')" :visible="show" cross :overlay="true" :persistent="true"
      @close="closeModal" transitionModal="sf-fade" transitionOverlay="sf-fade">
      <template #default>
        <p>{{ message }}</p>
        <div style="text-align: right">
          <a :href="switchLocalePath(locale)" @click="switchCNY">
            <SfButton class="sf-button--text">
              <SfCharacteristic class="language">
                <template #title>
                  <span>{{ $t('switch_CNY') }}</span>
                </template>
              </SfCharacteristic>
            </SfButton>
          </a>
        </div>
      </template>
    </SfModal>
  </div>
</template>

<script>
import {
  SfHeading,
  SfInput,
  SfButton,
  SfSelect,
  SfLink,
  SfAddressPicker,
  SfModal,
  SfCharacteristic,
  SfCheckbox
} from '@storefront-ui/vue';
import { useRouter, computed, onMounted, ref } from '@nuxtjs/composition-api';
import { usePreviewOrderStore } from '~/stores/previewOrder';
import VsfShippingProvider from '~/components/Checkout/VsfShippingProvider';
import ShippingAddressSelect from '~/components/MyAccount/ShippingAddressSelect';
import IdCard from '~/components/Checkout/IdCard';
import { usePreviewOrder } from '@bee-hole/coms';
import {
  VSF_CURRENCY_COOKIE
} from '@vue-storefront/core';
import { onSSR } from '@vue-storefront/core';
import { EventBus } from '@/plugins/eventBus';
export default {
  name: 'Shipping',
  components: {
    SfHeading,
    SfInput,
    SfButton,
    SfSelect,
    SfLink,
    VsfShippingProvider,
    ShippingAddressSelect,
    SfAddressPicker,
    IdCard,
    SfModal,
    SfCharacteristic,
    SfCheckbox
  },
  setup(props, context) {
    const router = useRouter();
    const { preorder, error: preOrderErr } = usePreviewOrder();
    const previewOrderStore = usePreviewOrderStore();
    const show = ref(false);
    const message = ref('');
    const PageNo = ref(previewOrderStore.billingPageNo);
    const { locale } = context.root.$i18n;
    // billingAndShipping和billingAddressChange是为了解决收货地址和账单地址是否一致的问题
    const billingAndShipping = ref(true);
    const billingAddressChange = () => {
      previewOrderStore.changeBillingAndShipping(billingAndShipping.value);
    };
    const addressId = computed(() => {
      return String(previewOrderStore?.address?.addressId || '');
    });
    const closeModal = () => {
      show.value = false;
    };
    // const { set: setError } = useApiError();
    const isCN = computed(() => {
      const currency = context?.root?.$cookies.get('vsf-currency');
      if (previewOrderStore?.address?.country === 'CN') {
        if (currency === 'CNY') {
          closeModal();
          return false;
        } else {
          // setError({ message: context.root.$t('中国地址请选择中国货币和中国语言'), code: 502 });
          // openModal();
          message.value = context?.root?.$t('address CN');
          return true;
        }
      } else {
        closeModal();
        return false;
      }
    });
    const storesetBuiling = () => {
      previewOrderStore.copyAddress();
    };
    // 选中收货地址
    const selectAddress = async (address, pageNo) => {
      if (address) {
        await previewOrderStore.setAddress(address);
        previewOrderStore.setshippingPageNo(pageNo);
        previewOrderStore.clearShippingMethods();
        if (billingAndShipping.value) {
          storesetBuiling();
        }
        EventBus.$emit('PreviewOrder', address);
      }
    };
    onMounted(async () => {
      await previewOrderStore.reset();
      await previewOrderStore.setCurrency(context.root.$cookies.get(VSF_CURRENCY_COOKIE));
    });
    onSSR(async () => {
      await previewOrderStore.reset();
    });
    const switchCNY = () => {
      context.root.$cookies.set(VSF_CURRENCY_COOKIE, 'CNY', {
        path: '/',
        sameSite: 'Lax',
        maxAge: 3600 * 24 * 365
      });
      context.root.$i18n.setNumberFormat(locale, {
        currency: {
          style: 'currency',
          currency: 'CNY',
          currencyDisplay: 'symbol'
        }
      });
      previewOrderStore.clearCode();
      previewOrderStore.setPrepay_id(null);
    };
    const goNext = () => {
      if (!billingAndShipping.value) {
        previewOrderStore.setBuiling(null);
        setTimeout(() => {
          router.push(context?.root?.localePath({ name: 'billing' }));
        }, 200);
      } else {
        storesetBuiling();
        router.push(context?.root?.localePath({ name: 'payment' }));
      }
    };
    return {
      router,
      addressId,
      selectAddress,
      preorder,
      preOrderErr,
      isCN,
      show,
      message,
      closeModal,
      switchCNY,
      locale,
      billingAddressChange,
      billingAndShipping,
      goNext,
      PageNo
    };
  }
};
</script>

<style lang="scss" scoped>
.form {
  --button-width: 100%;

  &__select {
    display: flex;
    align-items: center;
    --select-option-font-size: var(--font-size--lg);

    ::v-deep .sf-select__dropdown {
      font-size: var(--font-size--lg);
      margin: 0;
      color: var(--c-text);
      font-family: var(--font-family--secondary);
      font-weight: var(--font-weight--normal);
    }
  }

  @include for-desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    --button-width: auto;
  }

  &__element {
    margin: 0 0 var(--spacer-xl) 0;

    @include for-desktop {
      flex: 0 0 100%;
    }

    &--half {
      @include for-desktop {
        flex: 1 1 50%;
      }

      &-even {
        @include for-desktop {
          padding: 0 0 0 var(--spacer-xl);
        }
      }
    }
  }

  &__action {
    @include for-desktop {
      flex: 0 0 100%;
      display: flex;
    }
  }

  &__action-button {
    &--secondary {
      @include for-desktop {
        order: -1;
        text-align: left;
      }
    }

    &--add-address {
      width: 100%;
      margin: 0;

      @include for-desktop {
        margin: 0 0 var(--spacer-lg) 0;
        width: auto;
      }
    }
  }

  &__action-button2 {
    margin-left: 20px;
    // &--secondary {
    //   @include for-desktop {
    //     order: -1;
    //     text-align: left;
    //   }
    // }
    // &--add-address {
    //   width: 100%;
    //   margin: 0;
    //   @include for-desktop {
    //     margin: 0 0 var(--spacer-lg) 0;
    //     width: auto;
    //   }
    // }
  }

  &__back-button {
    margin: var(--spacer-xl) 0 var(--spacer-sm);

    &:hover {
      color: var(--c-white);
    }

    @include for-desktop {
      margin: 0 var(--spacer-xl) 0 0;
    }
  }
}

.add_shipping_link {
  margin-bottom: 20px;
}

.maringleft {
  margin-left: 20px;
}

.shipping {
  &__label {
    display: flex;
    justify-content: space-between;
  }

  &__description {
    --radio-description-margin: 0;
    --radio-description-font-size: var(--font-xs);
  }
}

.title {
  margin: var(--spacer-xl) 0 var(--spacer-base) 0;
}

.shppingList {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.shippingItem {
  margin-bottom: 20px;
}

.margintop {
  width: 100%;
}
</style>
